export default __webpack_public_path__ + "static/media/SMEETA_ARALIKATTI.816c2605.JPG";